<template>
  <div class="top-nav">
    <div class="back" v-if="!urlList.includes($route.path)">
      <img @click="back()" src="@/assets/back.png" />
      <span @click="back()">返回</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      urlList: ['/users', '/search', '/tasklist', '/examlist'],
    };
  },
  methods: {
    back() {
      if (this.$route.name === '任务详情') {
        this.$store.commit('setKeepAlive', ['task']);
        this.$router.push('/tasklist');
      } else this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.top-nav {
  width: 100%;
  min-width: 1440px;
  height: 60px;
  position: absolute;
  box-shadow: 0px 1px 4px 0px rgba(0, 21, 41, 0.12);
  background: #ffffff;
  z-index: 98;
}
.back {
  color: #49658a;
  padding: 22px 0px 0px 302px;
  height: 100%;
  text-align: left;
}
.back > span {
  cursor: pointer;
}
.back > img {
  cursor: pointer;
  width: 20px;
  margin: 1px 8px 0px 0px;
  vertical-align: text-top;
}
</style>
